import React, { useMemo } from 'react';
import classNames from 'classnames';

import { BadgeVariant } from './types';
import iconInfo from './icons/info.svg';
import iconWarning from './icons/warning.svg';
import iconDanger from './icons/danger.svg';
import * as styles from './styles/styles.module.scss';

type BadgeProps = {
  label: string;
  variant: BadgeVariant;
  title?: string;
};

const Badge = ({ label, variant, title }: BadgeProps): JSX.Element => {
  const [variantBadge, icon] = useMemo(
    () =>
      ({
        [BadgeVariant.Info]: [styles.badgeInfo, iconInfo],
        [BadgeVariant.Warning]: [styles.badgeWarning, iconWarning],
        [BadgeVariant.Danger]: [styles.badgeDanger, iconDanger]
      }[variant]),
    [variant]
  );

  return (
    <div className={classNames(styles.badge, variantBadge)}>
      <img src={icon} className={styles.icon} alt={variant} />
      <span className={styles.text} title={title || label}>
        {label}
      </span>
    </div>
  );
};

export default Badge;
